import { AssignmentResponseSchema, type AssignmentResponseType } from '../Planning/AssignmentApi';
import { type Api, ApiFilterBuilder } from '@automapa/svelte-automapa-template';
import type { QueriesType } from '../telematics/types';
import { z } from 'zod';
import { VehicleResponseSchema, type VehicleResponseType } from '../Vehicles/types';
import { WarehouseResponseSchema, type WarehouseResponseType } from '../Warehouses/WarehouseApi';
import {
    RoutePointExtendedSchema,
    type RoutePointExtendedType,
} from '../../utilities/RoutePointsApi';

export class GanttDumpApi {
    static async getAssignments(api: Api, selectedDay: string): Promise<AssignmentResponseType[]> {
        return api.getData<QueriesType, AssignmentResponseType[]>(
            'post',
            '/gantt_dump_api/get_assignments',
            { selected_day: selectedDay },
            z.object({ selected_day: z.string() }),
            z.array(AssignmentResponseSchema)
        );
    }

    static async getVehicles(api: Api, selectedDay: string): Promise<VehicleResponseType[]> {
        return api.getData<any, VehicleResponseType[]>(
            'post',
            '/gantt_dump_api/get_vehicles',
            { selected_day: selectedDay },
            z.any(),
            z.array(VehicleResponseSchema)
        );
    }

    static async getWarehouses(api: Api, selectedDay: string): Promise<WarehouseResponseType[]> {
        return api.getData<any, WarehouseResponseType[]>(
            'post',
            '/gantt_dump_api/get_warehouses',
            { selected_day: selectedDay },
            z.any(),
            z.array(WarehouseResponseSchema)
        );
    }

    static async getPoints(
        api: Api,
        assignmentId: number,
        selectedDay: string
    ): Promise<RoutePointExtendedType[]> {
        return api.getData<any, RoutePointExtendedType[]>(
            'post',
            '/gantt_dump_api/get_points',
            { assignment_id: assignmentId, selected_day: selectedDay },
            z.any(),
            z.array(RoutePointExtendedSchema)
        );
    }
}
